import structureTypes from 'common/constants/structureTypes'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import {
  EntityInterface,
  MasterBlockId,
} from 'common/types/entities/EntityInterface'
import { FormElementTypeEnum } from 'src/shared/types/entities/form-interface'
import { v4 as uuid } from 'uuid'

export const generateId = () => uuid()

export const generateHtmlAttrId = (
  entityType:
    | EntityTypeEnum
    | keyof typeof structureTypes
    | FormElementTypeEnum,
) => `${entityType.toLowerCase().replace('_', '-')}-${uuid().slice(0, 8)}`

export const generateCustomHtmlAttrId = (
  entityType: EntityTypeEnum,
  customString: string,
) =>
  `${entityType.toLowerCase().replace('_', '-')}-${customString}${uuid().slice(0, 8)}`

export const insertChild = (
  childIds: string[],
  id: string,
  position: number,
) => [...childIds.slice(0, position), id, ...childIds.slice(position)]

export function generateBaseEntity(
  type: EntityTypeEnum,
  parentId: string,
  masterBlockId?: string | MasterBlockId,
) {
  const baseEntity: Omit<EntityInterface, 'type'> = {
    id: generateId(),
    parentId: parentId,
    margin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    appearance: {
      desktop: true,
      mobile: true,
    },
    htmlAttrId: generateHtmlAttrId(type),
  }

  if (masterBlockId) {
    baseEntity.masterBlockId = masterBlockId
  }

  return baseEntity
}
